import { Icon, type IconName } from './Icon';

type Item<T extends string> = { id: T; label: string; icon: IconName; count?: number };

export function MapDock<T extends string>({
  items,
  active,
  onSelect,
}: {
  items: Item<T>[];
  active: T | null;
  onSelect: (id: T) => void;
}) {
  return (
    <nav className="map-dock" aria-label="Planspielbereiche">
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          aria-pressed={active === item.id}
          onClick={() => onSelect(item.id)}
        >
          <Icon name={item.icon} size={20} />
          <span>{item.label}</span>
          {item.count !== undefined ? <span className="dock-count">{item.count}</span> : null}
        </button>
      ))}
    </nav>
  );
}
